export const saves = {
	data() {
		return {
			allSaved: false,
			confirmationOpen: false,
			confirmationRemoveIds: null
		}
	},
	computed: {
		contentIds() {
			let contentIds = [];
			if (this.contents) {
				this.contents.forEach(function(content) {
					contentIds.push(content.id);
				});
			}

			return contentIds;
		}
	},
	methods: {
		getSave(saveId) {
			const save = saveId ? saveId : this.$store.state.save.uid;
			let savedContent = [];

			this.$store.commit('contentLoading', true);
			this.$saves
				.single(save, {
					include: 'content'
				})
				.then(response => {
					const data = response.getData().data;

					data.content.forEach(function(content) {
						savedContent.push(content.id);
					});

					this.$store.dispatch('updateSave', data);
					this.$store.commit('addSavedContent', savedContent);

					this.$nextTick(() => {
						this.checkAllSaved();
						this.$store.commit('contentLoading', false);
					});

					this.$store.commit('contentLoading', false);
				})
				.catch(() => {
					this.$store.commit('contentLoading', false);
					this.$store.commit('apiError', true);
				});
		},
		createSave(savedContent) {
			this.$store.commit('contentLoading', true);
			this.$saves
				.create({
					name: 'Create Save',
					content: savedContent
				})
				.then(response => {
					this.getSave(response.getData().data.uid);
				})
				.catch(() => {
					this.$store.commit('contentLoading', false);
					alert('Sorry, there was an issue, please try again');
				});
		},
		updateSave(savedContent) {
			this.$store.commit('contentLoading', true);
			this.$saves
				.update(this.$store.state.save.uid, {
					content: savedContent
				})
				.then(() => {
					this.getSave();
				})
				.catch(() => {
					this.$store.commit('contentLoading', false);
					alert('Sorry, there was an issue, please try again');
				});
		},
		addSave(newContent) {
			const savedContent = this.$store.state.savedContent;

			newContent.forEach(function(content) {
				if (!savedContent.includes(content)) {
					savedContent.push(content);
				}
			});

			if (this.$store.state.save && this.$store.state.save.id) {
				this.updateSave(savedContent);
			} else {
				this.createSave(savedContent);
			}
		},
		removeSave(newContent) {
			const savedContent = this.$store.state.savedContent;

			newContent.forEach(function(content) {
				if (savedContent.includes(content)) {
					const index = savedContent.indexOf(content);
					if (index > -1) {
						savedContent.splice(index, 1);
					}
				}
			});

			if (this.$store.state.save && this.$store.state.save.id) {
				this.updateSave(savedContent);
			} else {
				this.createSave(savedContent);
			}
		},
		remove(id) {
			this.confirmationRemoveIds = id;
			this.confirmationOpen = true;
		},
		checkAllSaved() {
			const savedContent = this.$store.state.savedContent;

			for (let id of this.contentIds) {
				if (!savedContent.includes(id)) {
					this.allSaved = false;
					break;
				}

				this.allSaved = true;
			};
		}
	},
	mounted() {
		this.$eventBus.$on('checkAllSaved', this.checkAllSaved);
		this.$eventBus.$on('getSave', this.getSave);
	}
};